import React from "react";
import { Modal, Box, Typography, Button, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useAnalytics } from "../../hooks/useAnalytics";

const SuccessModal = ({ open, onClose }) => {
  useAnalytics();
  
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isSmallScreen ? "65%" : 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <CheckCircleIcon sx={{ color: "green", fontSize: 60 }} />
        <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
          KYC Submitted Successfully!
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: "gray" }}>
          Your details are under review. We’ll notify you once verification is
          complete.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3, width: "100%" , background:"#ee7b0d"}}
          onClick={onClose}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
